import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { CustomValidators } from 'ng2-validation';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { environment } from 'environments/environment.prod';

const breadcrumb: any[] = [
  {
    title: 'Home'
    //link: 'default-layout/dashboard'
  },
  {
    title: 'User'
    //link: '#/default-layout/user'
  },
  {
    title: 'Edit user'
   // link: ''
  }
];

//const password = new FormControl('', Validators.required);
//const confirmPassword = new FormControl('', CustomValidators.equalTo(password));

@Component({
  selector: 'page-user-edit',
  templateUrl: './user-edit.html',
  styleUrls: ['./user-edit.scss']
})


export class PageUserEdit implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  public form: FormGroup;
  data: any;

  
  //diaglog
  dialogRef: MdDialogRef<userEditDialog>;
  selectedOption: string;

  to_id:string;
  rows=[]

  name:string;
  user:string;
  password:string;
  email:string;
  phone:string;
  address:string;
  permissionStr:string;
  permissionShow:string;
  permissionsMobilesStr:string;
  permissionsMobilesShow:string;
  permissions = [
    { value: '1', viewValue: 'Administrator' },
    { value: '2', viewValue: 'CEO' },
    { value: '3', viewValue: 'PC1' },
    { value: '4', viewValue: 'PC2' },
    { value: '5', viewValue: 'PU' },
    { value: '6', viewValue: 'QC' },
    { value: '7', viewValue: 'PD' }
  ];
  
  permissionsMobiles = [
    { value: '0', viewValue: 'N/A' },
    { value: '1', viewValue: 'Plan matterial'},
    { value: '11', viewValue: 'Plan platting' },
    { value: '2', viewValue: 'Receive Material' },
    { value: '6', viewValue: 'Receive platting' },
    { value: '3', viewValue: 'Dandoriman' },
    { value: '5', viewValue: 'Collect platting' },
    { value: '7', viewValue: 'Packing' },
    { value: '8', viewValue: 'Collect and Sale' },
    { value: '9', viewValue: 'Quality Control' },
    { value: '10', viewValue: 'Change lot size' },
    { value: '12', viewValue: 'Production' }
  ];

  constructor(private activatedRoute: ActivatedRoute,public dialog: MdDialog,private fb: FormBuilder, private _sharedService: SharedService,private router: Router) {

    this._sharedService.emitChange(this.pageTitle);
  }

  fetch(cb) {
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_user_all.php?id='+this.to_id);

    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }

    openDialog() {
    let dialogRef = this.dialog.open(userEditDialog);
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      
      if(result==='1'){
        this.postString();
        console.log('---result---',result);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }

    });
  }

  getPermission(permission,permissionShow) {
    this.permissionStr = permission;
    this.permissionShow = permissionShow;
    console.log('permission',permission);
  }
  getPermissionMobile(permissionMobile,permissionsMobilesShow) {
    this.permissionsMobilesStr = permissionMobile;
    this.permissionsMobilesShow = permissionsMobilesShow;
    console.log('permission',permissionMobile);
  }

  postString() {
    this.data = "id="+this.to_id+"&permissionmobile="+this.permissionsMobilesStr+"&permission="+this.permissionStr+"&user="+this.form.controls.user.value+"&password="+this.form.controls.password.value+"&address="+this.form.controls.address.value+"&name="+this.form.controls.name.value.replace(/&/g, '^')+"&email="+this.form.controls.email.value+"&phone=" + this.form.controls.phone.value;
    //this.data = "branch="+this.form.controls.branch.value+"&taxid="+this.form.controls.taxid.value+"&address="+this.form.controls.address.value+"&id="+this.to_id+"&shortname="+this.form.controls.shortname.value.replace(/&/g, '^')+"&fullname="+this.form.controls.fullname.value.replace(/&/g, '^')+"&contactname=" + this.form.controls.contactname.value + "&phone=" + this.form.controls.phone.value + "&email=" + this.form.controls.email.value + "&website=" + this.form.controls.website.value;
    const req = new XMLHttpRequest();
    req.open('POST',  environment.url+'/api/editUser.php', true);

    //Send the proper header information along with the request
    req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

    req.onreadystatechange = function () {//Call a function when the state changes.
      if (req.readyState == XMLHttpRequest.DONE && req.status == 200) {
        // Request finished. Do processing here.
        req.onload = () => {
          console.log(JSON.parse(req.response));
          //JSON.parse(req.response);
        };
      }
    }
    req.send(this.data);
    console.log('----data-----', this.data);

  
  this.router.navigateByUrl('default-layout/user');

  }



  ngOnInit() {

    this.activatedRoute.params.subscribe((params: Params) => {
        this.to_id = params['id'];
        console.log('--id--',this.to_id);
      });

      this.fetch((data) => {
        // cache our list
       
        //this.model=data[0]['tp_productname'];
        // push our inital complete list
  
        console.log('------data------',data);
        this.rows = data;
        this.name = this.rows[0].to_fullname;
        this.phone = this.rows[0].to_phone;
        this.email = this.rows[0].to_email;
        this.address = this.rows[0].to_address;
        this.user = this.rows[0].to_user;
        //this.password = this.rows[0].to_password;
        this.permissionStr=this.rows[0].to_permission_web_value;
        this.permissionsMobilesStr=this.rows[0].to_permission_value;
        this.permissionShow=this.rows[0].to_permission_web;
        this.permissionsMobilesShow=this.rows[0].to_permission;
        
      });


    this.form = this.fb.group({
      //stateCtrl: [null, Validators.compose([Validators.required])],
      name: [null, Validators.compose([Validators.required])],
      password: [null, Validators.compose([Validators.required])],
      user: [null, Validators.compose([Validators.required])],
      phone: [null, Validators.compose([Validators.required])],
      email: [null, Validators.compose([Validators.required])],
      address: [null, Validators.compose([Validators.required])]
    
    });



  }
}

//dialog
@Component({
  selector: 'user-dialog',
  templateUrl: 'dialog.html',
})
export class userEditDialog {
  Message = 'What would you like to do?';
  constructor(public dialogRef: MdDialogRef<userEditDialog>) {}
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/user/user-edit.ts